// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { updateHeaderToken } from 'helpers/api'

export const setAuthInStorage = (token, expires) => {
  // if a token is provided, then set it, otherwise, remove user session data from local storage.
  if (token) {
    localStorage.setItem('L_JWT', token)
    localStorage.setItem('L_ETS', expires)
  } else {
    localStorage.removeItem('L_JWT')
    localStorage.removeItem('L_ETS')
  }
}

export const logIn = async (jwtToken, expirationDate) => {
  await setAuthInStorage(jwtToken, expirationDate)
  updateHeaderToken(jwtToken)
}

export const logOut = () => {
  setAuthInStorage()
  history.replaceState(null, '', '/')
  window.location.reload()
}

// takes the expiration date and creates a setTimeout based on the time remaining.
export const setSessionTimeout = expirationDate => (
  setTimeout(() => { logOut() }, expirationDate - Date.now())
)
